<template>
  <div class="px-[16px]">
    <!-- Navigation Tabs -->
    <div class="mb-[12px]">
      <div class="inline-flex items-center bg-[#f3f4f6] border border-[#e5e7eb] rounded-[8px] p-[3px] gap-[3px]">
        <button
          type="button"
          class="border-0 px-[16px] py-[6px] text-[13px] rounded-[6px] cursor-pointer transition-all duration-200 focus:outline-none"
          :class="tabIndex === 0 ? 'bg-white text-[#111827] font-semibold shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]' : 'bg-transparent text-[#4b5563] font-medium hover:text-[#111827]'"
          @click="tabIndex = 0"
        >
          Biaya Ekspedisi
        </button>
        <button
          type="button"
          class="border-0 px-[16px] py-[6px] text-[13px] rounded-[6px] cursor-pointer transition-all duration-200 focus:outline-none"
          :class="tabIndex === 1 ? 'bg-white text-[#111827] font-semibold shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]' : 'bg-transparent text-[#4b5563] font-medium hover:text-[#111827]'"
          @click="tabIndex = 1"
        >
          Service Ekspedisi
        </button>
      </div>
    </div>

    <!-- Tab Content -->
    <div>
      <div v-if="tabIndex === 0">
        <ROTableExpeditionsFee :source="source" />
      </div>
      <div v-else>
        <ROTableExpeditionsService :source="source" />
      </div>
    </div>
  </div>
</template>

<script>
import ROTableExpeditionsFee from './component/ROTableExpeditionsFee.vue'
import ROTableExpeditionsService from './component/ROTableExpeditionsService.vue'

export default {
  name: 'ROExpeditionSchema',
  components: { ROTableExpeditionsFee, ROTableExpeditionsService },
  props: {
    source: {
      type: String,
      default: 'rajaongkir',
    },
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
}
</script>
